import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const savedTheme = localStorage.getItem('ekyc-theme');

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    dark: savedTheme === 'dark',
    themes: {
      light: {
        primary: '#143049',
        background: colors.grey.lighten5,
      },
      dark: {
        primary: '#143049',
        anchor: '#5c9ecf',
        background: '#121212',
      },
    },
  },
});
